import { useCallback, useEffect, useRef, useState } from "react"
import { getAdminCommunityMastermind, getAdminCommunityOpen, getAdminCommunityPending, getAdminCommunityStats } from "../../services/membersAdminService";
import { CommunityFormEnum } from "../../pages/community/enums/CommunityFormEnum";
import { CommunityPost } from "./models/CommunityPost";

interface APITableResult<T> {
    count: number;
    next: T | null;
    previous: T | null;
    results: T[];
}

export const useCommunityMemeberPending = (userId: number, section: CommunityFormEnum, reloadKey?: number) => {
    const isMountedRef = useRef(true);
    const [loading, setLoading] = useState(false);
    const [pending, setPending] = useState<CommunityPost[]>([]);
    const [pendingPage, setPendingPage] = useState(1);
    const [pendingTotalPages, setPendingTotalPages] = useState(0);

    useEffect(() => {
        isMountedRef.current = true;
        return () => {
            isMountedRef.current = false;
        }
    }, []);

    const totalPages = (count: number) => Math.ceil(count / 5);

    const load = useCallback(async () => {
        if(!userId)
            return;
        try {
            setLoading(true);
            const _pending = await getAdminCommunityPending(userId, section === CommunityFormEnum.MASTERMIND_CIRCLE ? 'circle': 'forum', pendingPage-1) as APITableResult<CommunityPost>

            if(!isMountedRef.current)
                return;
            if(!!_pending) {
                setPending(_pending.results);
                setPendingTotalPages(totalPages(_pending.count));
            }
        }
        finally {
            if(!isMountedRef.current)
                return;
            setLoading(false);
        }
    }, [userId, pendingPage, section, reloadKey]);

    useEffect(() => {
        load();
    }, [load]);

    return { 
        loading, 
        pending,
        pendingPage,
        pendingTotalPages,
        setPendingPage
    }
}